// extracted by mini-css-extract-plugin
module.exports = {"loadingLbl":"Results_loadingLbl__1yLSF","trash":"Results_trash__1OJYk","arrow":"Results_arrow__3iZ9t","type":"Results_type__bqMl7","color":"Results_color__3dNeg"};